namespace $.$$ {
	$mol_style_define( $shm_showcase_group, {
		':not(:first-child)': {
			borderTop: '1px solid var(--mol_theme_line)',
		},
		Content: {
			flex: { wrap: 'wrap' },
			padding: { bottom: $mol_gap.block },
		},
	} )
}
